<template>
  <div class="units-top-panel">
    <div class="is-flex is-justify-content-flex-end">
      <div class="add-unit">
        <el-button type="primary" icon="el-icon-plus" @click="openModal">
          Добавить еденицу измерения
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnitsTopPanel',
  methods: {
    openModal() {
      this.$emit('create-unit');
    },
  },
};
</script>
